function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 8.52051C16.5 12.6626 13.1421 16.0205 9 16.0205C4.85786 16.0205 1.5 12.6626 1.5 8.52051C1.5 4.37837 4.85786 1.02051 9 1.02051C13.1421 1.02051 16.5 4.37837 16.5 8.52051Z",
  fill: "#4290F3",
  fillOpacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 8.52051C15.75 12.2484 12.7279 15.2705 9 15.2705V16.7705C13.5563 16.7705 17.25 13.0769 17.25 8.52051H15.75ZM9 15.2705C5.27208 15.2705 2.25 12.2484 2.25 8.52051H0.75C0.75 13.0769 4.44365 16.7705 9 16.7705V15.2705ZM2.25 8.52051C2.25 4.79259 5.27208 1.77051 9 1.77051V0.270508C4.44365 0.270508 0.75 3.96416 0.75 8.52051H2.25ZM9 1.77051C12.7279 1.77051 15.75 4.79259 15.75 8.52051H17.25C17.25 3.96416 13.5563 0.270508 9 0.270508V1.77051Z",
  fill: "#4290F3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7676 6.35352L10.7676 10.3535",
  stroke: "#4290F3",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.89844 6.35352L6.89844 10.3535",
  stroke: "#4290F3",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.c4636843.svg";
export { ForwardRef as ReactComponent };